import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_banner_pitch = _resolveComponent("banner-pitch")!
  const _component_highlight_overlay = _resolveComponent("highlight-overlay")!
  const _component_four_stats_pitch = _resolveComponent("four-stats-pitch")!
  const _component_pros_cons_pitch = _resolveComponent("pros-cons-pitch")!
  const _component_three_detailed_pitch = _resolveComponent("three-detailed-pitch")!
  const _component_three_column_pitch = _resolveComponent("three-column-pitch")!
  const _component_pitch_image = _resolveComponent("pitch-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_banner_pitch, {
      image: $data.pitches.banner.imageSrc,
      pageDescription: "Savings For Employers"
    }, {
      bannerHTMLLarge: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "display-4" }, "Watch Your Pharmacy Spending Go Down", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "pitch-font" }, "IntelligentRx + Your Insurance Company = Up To 30% Savings", -1)),
        _createVNode(_component_router_link, {
          to: "/request-a-demo",
          class: "btn btn-lg",
          style: {"background":"var(--background-color-attention-emphasis) 0% 0% no-repeat padding-box","color":"black"}
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createTextVNode(" Request a Demo ", -1)),
            _createVNode(_component_font_awesome_icon, {
              icon: "fa fa-arrow-right",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        })
      ]),
      bannerHTMLMobile: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "d-inline-block" }, "Watch Your Pharmacy Spending Go Down", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "pitch-font" }, " IntelligentRx's Pharmacy Team + Your Existing Insurance Company = Up To 30% Savings ", -1)),
        _createVNode(_component_router_link, {
          to: "/request-a-demo",
          class: "btn btn-lg my-4",
          style: {"background":"var(--background-color-attention-emphasis) 0% 0% no-repeat padding-box","color":"black"}
        }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createTextVNode("Request a Demo ", -1)),
            _createVNode(_component_font_awesome_icon, {
              icon: "fa fa-arrow-right",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["image"]),
    _createVNode(_component_highlight_overlay, {
      title: $data.pitches.highlightOverlayThomas.title,
      text: $data.pitches.highlightOverlayThomas.text,
      imageSrc: $data.pitches.highlightOverlayThomas.imageSrc
    }, null, 8, ["title", "text", "imageSrc"]),
    _createVNode(_component_four_stats_pitch, {
      title: "How We Save Money",
      fourStats: $data.pitches.commonProblemSolutionStats,
      overallClass: 'pitch-background-default'
    }, null, 8, ["fourStats"]),
    _createVNode(_component_pros_cons_pitch, {
      title: "Is IntelligentRx Right For You?",
      description: "",
      prosCons: $data.pitches.commonProsCons,
      overallClass: 'pitch-background-dark'
    }, null, 8, ["prosCons"]),
    _createVNode(_component_three_detailed_pitch, {
      title: "Managing Complexity",
      pitches: $data.pitches.managingComplexity,
      overallClass: 'pitch-background-gradient'
    }, null, 8, ["pitches"]),
    _createVNode(_component_three_column_pitch, {
      title: "Our Offerings",
      pitches: $data.pitches.employerOurValuesInOurProduct,
      overallClass: 'pitch-background-default'
    }, null, 8, ["pitches"]),
    _createVNode(_component_three_column_pitch, {
      title: "Employer's Return On Investment",
      pitches: $data.pitches.employerROI,
      overallClass: 'pitch-background-dark',
      iconClass: 'pitch-background-dark-invert-icon-class'
    }, null, 8, ["pitches"]),
    _createVNode(_component_three_detailed_pitch, {
      title: "How IntelligentRx For Employers Works",
      pitches: $data.pitches.howItWorks,
      overallClass: 'pitch-background-gradient'
    }, null, 8, ["pitches"]),
    _createVNode(_component_pitch_image, {
      title: $data.pitches.discountCards.title,
      text: $data.pitches.discountCards.text,
      imageLeft: true,
      imageSrc: $data.pitches.discountCards.imageSrc
    }, null, 8, ["title", "text", "imageSrc"]),
    _createVNode(_component_three_column_pitch, {
      title: "Integrating With Your Existing Plan",
      pitches: $data.pitches.integratingWithExistingPlan,
      overallClass: 'pitch-background-dark',
      iconClass: 'pitch-background-dark-invert-icon-class'
    }, null, 8, ["pitches"]),
    _createVNode(_component_pitch_image, {
      title: $data.pitches.securityPitch.title,
      text: $data.pitches.securityPitch.text,
      imageLeft: false,
      imageSrc: $data.pitches.securityPitch.imageSrc,
      overallClass: 'pitch-background-gradient'
    }, null, 8, ["title", "text", "imageSrc"])
  ]))
}